module.exports = __webpack_public_path__ + "images/template-share-gold.095a29ff972285ef58b6.svg";